<template>
  <div class="absolute pin-l pin-t pin-b pin-r z-10 m-0">
    <l-map
      ref="map"
      :zoom="zoomLevel"
      :min-zoom="3"
      :max-zoom="13"
      :center="mapCenter"
      @click="mapClicked"
      @move="$emit('mapMoved')"
    >
      <!-- Map tiles -->
      <l-tile-layer :url="mapUrl"></l-tile-layer>
      <!-- Markers (clustered) -->
      <l-marker-cluster>
        <l-marker
          v-if="showMarkers && p.latlng"
          v-for="p in markers"
          :lat-lng="p.latlng"
          :key="p.id"
          :draggable="false"
          @click="$emit('markerClicked', p)"
        ></l-marker>
      </l-marker-cluster>
      <!-- New point marker -->
      <l-marker
        v-if="showNewPoint"
        :lat-lng="newPoint"
        :draggable="true"
      ></l-marker>
    </l-map>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import L from "leaflet";
import { LMap, LTileLayer, LMarker, LPopup } from "vue2-leaflet";
import LMarkerCluster from "vue2-leaflet-markercluster";
import "../../node_modules/leaflet/dist/leaflet.css";

export default {
  // global
  name: "student-map",

  // interface
  props: ["markers"],

  components: { LMap, LTileLayer, LMarker, LPopup, LMarkerCluster },

  // local state
  data() {
    return {
      zoomLevel: 3,
      mapCenter: this.$store.state.initialMapCenter,
      mapUrl: `https://api.mapbox.com/styles/v1/basil-lcf/cklqiitpe6buy17ml00dx69h0/tiles/256/{z}/{x}/{y}@2x?access_token=pk.eyJ1IjoiYmFzaWwtbGNmIiwiYSI6ImNrOHI1cGViaTA2YTkzZnFhczdwZndieDgifQ.6Ndi4XXx0jWaWOuS4-AQOQ`,
    };
  },
  computed: {
    ...mapGetters(["currentState", "newPoint", "newCenter"]),
    mapComponent() {
      return this.$refs.map.mapObject;
    },
    showNewPoint() {
      return this.$route.name == "add-point" && this.newPoint;
    },
    showMarkers() {
      return ["browse", "profile"].includes(this.$route.name);
    },
  },
  watch: {
    newCenter(newVal) {
      this.mapCenter = newVal;
      const initial = this.$store.state.initialMapCenter;
      if (newVal[0] != initial[0] && newVal[1] != initial[1]) {
        setTimeout(() => {
          this.zoomLevel = 8;
        }, 500);
      } else this.zoomLevel = this.$store.state.initialZoomLevel;
    },
  },
  // lifecycle events
  mounted() {
    // Move the zoom control to the right
    this.mapComponent.zoomControl.remove();
    L.control.zoom({ position: "topright" }).addTo(this.mapComponent);
    // Hack to force the map to render fully on iPhone
    // See: https://github.com/KoRiGaN/Vue2Leaflet/issues/96#issuecomment-341459943
    setTimeout(function () {
      window.dispatchEvent(new Event("resize"));
    }, 250);
  },

  // non-reactive
  methods: {
    mapClicked(e) {
      if (this.$route.name == "add-point" && this.currentState == "addPoint") {
        const latlng = [e.latlng.lat, e.latlng.lng];
        this.$store.commit("setPinLatLng", { latlng: latlng });
      } else if (this.$route.name == "user-profile")
        // transition away from the user profile
        this.$router.push({ name: "browse" });
    },
  },
};
</script>


// WEBPACK FOOTER //
// StudentMap.vue?b3a23208